import { useState } from 'react';

import { message } from 'antd';
import clsx from 'clsx';
import copy from 'copy-to-clipboard';

import BunIcon from '@/assets/bun.svg?react';
import BushIcon from '@/assets/bush.svg?react';
import CopyHoverIcon from '@/assets/copy-hover.svg?react';
import CopyIcon from '@/assets/copy.svg?react';
import NpmIcon from '@/assets/npm.svg?react';
import PnpmIcon from '@/assets/pnpm.svg?react';
import YarnIcon from '@/assets/yarn.svg?react';
import { getCliInstallCommand } from '@/utils/cliInstallEnv';
import { isInternalDomain } from '@/utils/const';

import css from './index.module.less';

type PackageManager = 'bash' | 'npm' | 'pnpm' | 'yarn' | 'bun';

// 对外域名只允许 bash 安装
const getAllowedPackageManagers = (): PackageManager[] => {
  if (isInternalDomain()) {
    return ['bash', 'npm', 'pnpm', 'yarn', 'bun'];
  }
  return ['bash'];
};

const getInstallCommands = (): Record<PackageManager, string> => ({
  bash: getCliInstallCommand(),
  npm: 'npm install -g @ks-codeflicker/cli',
  pnpm: 'pnpm add -g @ks-codeflicker/cli',
  yarn: 'yarn global add @ks-codeflicker/cli',
  bun: 'bun add -g @ks-codeflicker/cli',
});

const INSTALL_COMMANDS = getInstallCommands();

export function InstallSection() {
  const allowedPMs = getAllowedPackageManagers();
  const [selectedPM, setSelectedPM] = useState<PackageManager>(allowedPMs[0] || 'bash');
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = () => {
    const success = copy(INSTALL_COMMANDS[selectedPM]);
    if (success) {
      message.success('复制成功');
    }
  };

  return (
    <div className={clsx(css['install-section'])}>
      <div className={clsx(css['install-container'])}>
        <div className={clsx(css['install-card'])}>
          {/* 标签栏 */}
          <div className={clsx(css['tabs-container'])}>
            <button
              className={clsx(css['tab'], selectedPM === 'bash' && css['tab-active'])}
              onClick={() => setSelectedPM('bash')}
            >
              <BushIcon className={clsx(css['tab-icon'])} />
              <span>bash</span>
            </button>
            {isInternalDomain() && (
              <>
                <button
                  className={clsx(css['tab'], selectedPM === 'npm' && css['tab-active'])}
                  onClick={() => setSelectedPM('npm')}
                >
                  <NpmIcon className={clsx(css['tab-icon'])} />
                  <span>npm</span>
                </button>
                <button
                  className={clsx(css['tab'], selectedPM === 'pnpm' && css['tab-active'])}
                  onClick={() => setSelectedPM('pnpm')}
                >
                  <PnpmIcon className={clsx(css['tab-icon'])} />
                  <span>pnpm</span>
                </button>
                <button
                  className={clsx(css['tab'], selectedPM === 'yarn' && css['tab-active'])}
                  onClick={() => setSelectedPM('yarn')}
                >
                  <YarnIcon className={clsx(css['tab-icon'])} />
                  <span>yarn</span>
                </button>
                <button
                  className={clsx(css['tab'], selectedPM === 'bun' && css['tab-active'])}
                  onClick={() => setSelectedPM('bun')}
                >
                  <BunIcon className={clsx(css['tab-icon'])} />
                  <span>bun</span>
                </button>
              </>
            )}
          </div>

          {/* 命令展示区 */}
          <div className={clsx(css['command-container'])}>
            <div className={clsx(css['command-text'])}>{INSTALL_COMMANDS[selectedPM]}</div>
            <button
              className={clsx(css['copy-btn'])}
              onClick={handleCopy}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {isHovered ? <CopyHoverIcon /> : <CopyIcon />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
